import { z } from 'zod';
import { parsePhone } from '../phone/phone.js';
/**
 * Incomplete customer details (debts.md section 22.1, Jira KAN-62). A debtor
 * whose name or phone has an issue receives no money movement until an
 * employee corrects it, or until its accounts move under the customer that
 * already holds the phone (section 22.4).
 */
export const DEBTOR_PROFILE_ISSUES = [
    'NAME_MISSING',
    'NAME_INVALID',
    'PHONE_MISSING',
    'PHONE_INVALID',
];
export const debtorProfileIssueSchema = z.enum(DEBTOR_PROFILE_ISSUES);
/** An Arabic or Latin letter; Arabic-Indic digits and punctuation are not letters. */
const NAME_LETTER = /(?=\p{L})[\p{Script=Arabic}\p{Script=Latin}]/u;
/** A name trimmed, with inner spaces collapsed, as every name is stored. */
export function cleanDebtorName(name) {
    return name.trim().replace(/\s+/g, ' ');
}
/**
 * The issue of a customer name, or null: empty (NAME_MISSING), shorter than
 * two characters or without any Arabic or Latin letter (NAME_INVALID, for
 * example «23423» or «---»). «qweqwe» and names with a note stay valid.
 */
export function debtorNameIssue(name) {
    const clean = cleanDebtorName(name ?? '');
    if (clean === '')
        return 'NAME_MISSING';
    if (clean.length < 2 || !NAME_LETTER.test(clean))
        return 'NAME_INVALID';
    return null;
}
/**
 * The issues of a stored debtor: its name, and its phone, which must be a
 * valid mobile under the shared rule. A stored phone of an excluded country
 * is not an issue (customers.md section 9.7: existing data is not changed).
 */
export function debtorProfileIssues(debtor) {
    const issues = [];
    const name = debtorNameIssue(debtor.name);
    if (name)
        issues.push(name);
    if (debtor.phone === null || debtor.phone.trim() === '') {
        issues.push('PHONE_MISSING');
    }
    else if (!parsePhone(debtor.phone, undefined, { allowExcludedCountry: true }).ok) {
        issues.push('PHONE_INVALID');
    }
    return issues;
}
/** `error.data` of CUSTOMER_PROFILE_INCOMPLETE. */
export const profileIncompleteDataSchema = z.object({
    debtorId: z.string(),
    name: z.string(),
    issues: z.array(debtorProfileIssueSchema),
});
//# sourceMappingURL=profile.js.map